import React from "react";
import Spinner from "../spinners/spinner";
import "./tableRb.css";
import { humanize } from "../Reports/Components/utils";
import DataNotFound from "../DataNotFound/DataNotFound";

const TableRb = (props) => {
 
  const dummyDataForSkeleton = Array.from({ length: 50 }, (_, index) => `row_${index + 1}`);
  return (
    <>
    <div
      className={
        props?.className
          ? "main-tableRb-body position-relative d-flex flex-column" + props?.className
          : "main-tableRb-body position-relative d-flex flex-column"
      }
    >
      <div
        className={
          "tableRb text-center" +
          (props?.tableclassName ? props?.tableclassName : "")
        }
      >
        {props.isLoading && (
          <div className="good position-absolute top-50 start-50">
            <Spinner size={"small"} shape={"border"} />
          </div>
        )}

        {props.shimmer ? (
          <>
            <div className="">
              <table className="campaign-list-table campaign-list-center">
                <thead className="fixed-table">
                  <tr className="main-table-row-fixed">
                    {props.tableHeads?.map((th, mainIndex) => {
                      return <th key={th?.id} className={props?.hiddenKeys?.includes(mainIndex) ? "d-none" : "targeting-table-heads"}> {th.fieldName ?? humanize(th.shortTitle)} </th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {dummyDataForSkeleton?.map((row, index) => {
                    return (
                      <tr key={row}>
                        {props.tableHeads?.map((data, mainIndex) => {
                          return (
                            <td key={data?.id} style={{border:"1px solid #ccc"}} className={props?.hiddenKeys?.includes(mainIndex) ? "d-none" : ""}>
                              <div className="td-with-loader">
                                <Spinner shimmer={true} />
                              </div>
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>
        ) : props?.noDataFound ? (
          <>
            <DataNotFound description={props?.noDataFoundDescription}/>
          </>
        ) : (
          props.table
        )}
      </div>
     
    </div>
  
    </>
  );
};

export default TableRb;

